import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Generic controller for auto-saving a boolean toggle field via PATCH.
// Usage:
//   div[data-controller="toggle-field"
//       data-toggle-field-url-value="/admin/users/123"
//       data-toggle-field-field-value="can_order_leads"]
//     input[type="checkbox" data-action="change->toggle-field#save"]
export default class extends Controller {
  static values = { url: String, field: String, label: { type: String, default: "Setting" } }

  async save(event) {
    const checked = event.target.checked
    const body = new FormData()
    body.append("field", this.fieldValue)
    body.append("value", checked ? "1" : "0")

    try {
      const response = await patch(this.urlValue, {
        body,
        responseKind: "json",
      })
      if (response.ok) {
        const status = checked ? "enabled" : "disabled"
        if (typeof window.showToast === "function") {
          window.showToast(`${this.labelValue} ${status}`, checked ? "bg-success" : "bg-danger")
        }
      } else {
        event.target.checked = !checked
        if (typeof window.showToast === "function") {
          window.showToast("Failed to update setting. Please try again.", "bg-danger")
        }
      }
    } catch {
      event.target.checked = !checked
      if (typeof window.showToast === "function") {
        window.showToast("Failed to update setting. Please try again.", "bg-danger")
      }
    }
  }
}
